// src/pages/public/ServiceInfo.jsx
import styles from "./ServiceInfo.module.css";
import service_illustration from "../../assets/img_service_info.png";

export default function ServiceInfo() {
    return (
        <main>
            <section className={styles.pageSection} aria-label="서비스 안내">
                <div className={styles.content}>
                    {/* <h1 className={styles.title}>서비스 안내</h1> */}
                    <h2 className={styles.subtitle}>
                        화재 확산 예측 실시간 시뮬레이션
                    </h2>
                    <p className={styles.desc}>
                        화재 시뮬레이션의 산업 현장 근로자, 소방 분야 종사자, 도시 계획가 및 
                        건축 엔지니어 등 다양한 사용자가 최소의 비용으로 화재재난에 대한 
                        대응 능력을 강화할 수 있습니다.
                    </p>
                    <p className={styles.desc}>
                        FirST SIM 서비스의 실시간 시뮬레이션으로 예측된 화재 확산 경로를 고려하여
                        요구조자에게 적시에 통제정보 및 최적의 분산 피난 경로를 제공할 수 있으며,
                        화재 확산 결과를 예측하여 조기 경보 발령 및 인명 구조를 위한 선제적 대응을
                        강화할 수 있습니다.
                    </p>
                </div>
                <div className={styles.image}>
                    <img src={service_illustration} alt="서비스 안내 일러스트" />
                </div>
            </section>
        </main>
    );
}